import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
// import Autocomplete, {
//     createFilterOptions
// } from "@mui/material/lab/Autocomplete";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
// import { AssignmentInd } from "@mui/icons-material";
import {
    Alert, Row,
    Col,
    Card
} from "reactstrap";
import { makeStyles } from "@mui/styles";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getTransactionListsRefund } from "../../redux/actions/getTransactionListRefundAction";
import { getRefunds } from "../../redux/actions/getRefundPartnerAction"
import Util from "../../validation/index";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import pending from "../../assets/img/pending.png"
import proccessing from '../../assets/img/proccessing.png'
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import moment from "moment";
import { FormControl } from "@mui/material";
import { getUserNameContactSuggestionList } from "../../redux/actions/partnerGetUserNameContactSuggestionAction"
import getSymbolFromCurrency from "currency-symbol-map";
import {
    resetGetCustomerIdAndNameList,
    getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
// import {
//     MuiPickersUtilsProvider,
//     DatePicker
// } from "@mui/material/pickers";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});



const Refund = () => {
    const classes = useStyles();
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [pageNo, setPageNo] = useState(0)
    // const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(false);

    const [getTransListRefundStatus, setGetTransListRefundStatus] = useState(false);
    const [getTransRefundListArray, setGetTransRefundListArray] = useState([]);
    const [customerOrMobName, setCustomerOrMobName] = useState("");
    const [toCustName, setToCustName] = useState("")


    const [getRefundStatus, setGetRefundStatus] = useState(false);
    const [RefundArray, setRefundListArray] = useState([]);

    const [notificationRefundOpen, setNotificationRefundOpen] =
        React.useState(false);
    const [reverseBtnAction, setReverseBtnAction] = useState(false);
    const [memberId, setMemberId] = useState("");

    var date = new Date();
    const [selectedDate, setSelectedDate] = useState(
        new Date(date.getFullYear(), date.getMonth(), 1)
    );
    const [searchLoading, setSearchLoading] = useState(false);

    // console.log(selectedDate, "Refund_date");
    const [selectedToDate, setSelectedToDate] = useState(new Date());
    // console.log(selectedToDate, "Refund_date1");

    const login = useSelector((state) => state.login);


    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    const getCustomerIdAndNameListRes = useSelector(
        ({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
    );
    var authToken = regenerateTokenRes.data.AuthToken;

    const getRefundRes = useSelector(
        ({ partnerGetRefundList }) => partnerGetRefundList
    );

    const getTransactionListRefundRes = useSelector(
        ({ partnerGetTransactionListsRefunds }) => partnerGetTransactionListsRefunds
    );
    const getUsernameContactSuggestionRes = useSelector(
        ({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
    )
    const getUsernameSuggestionRes = useSelector(
        ({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
    )
    const dispatch = useDispatch();
    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    // };
    const [getRemark, setGetRemark] = useState("");
    const [remarkError, setRemarkError] = useState("");
    const handleChangePageForward = (pageaa, newPage) => {
        setPageNo(newPage);

        // getWalletTransactionListReq()
        // console.log("Arrow", newPage)
    };

    // const handleChangeRowsPerPage = (event) => {

    //     setRowsPerPage(parseInt(event.target.value));
    //     setPageNo(0);

    // };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        const currentFirstRowIndex = pageNo * rowsPerPage;
        const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);

        setRowsPerPage(newRowsPerPage);
        setPageNo(newPage);
    };
    // const handleChangeEvent=(e)=>{
    //     const { value } = e.target;
    //     if (/^\d*$/.test(value)) {
    //       setRefundAmount(value);
    //     }
    // }

    const handleChangeEvent = (e) => {
        const { value } = e.target;

        // Regex to match integer or float (positive, with optional decimals)
        if (/^\d*\.?\d*$/.test(value)) {
            setRefundAmount(value);
        }
    }

    const handleChange = ({ target: { name, value } }) => {
        // if (name === "refundAmount") {
        //     console.log("VALUESSSS", value)
        //     setRefundAmount(value);
        // }
        // if (name === "getRemark") {
        //     // console.log("VALUESSSS", value)
        //     setGetRemark(value);
        // }
        if (name === "getRemark") {
            const allowedPattern = /^[a-zA-Z0-9 '"\\-]*$/;

            if (!allowedPattern.test(value)) {
                setRemarkError("Only alphanumeric characters, spaces, ' \" and - are allowed.");
            } else {
                setRemarkError(""); // Clear error
                setGetRemark(value);
            }
        }
        if (name === "customerOrMobName") {

            // console.log("custttttNammmmee", customerOrMobName)
            setCustomerOrMobName(value)
            // onCustContactFunc(value)


        }
        if (name === "toCustName") {
            // Util.verifyAlphabet(value)
            //     ? setToCustName(value)
            //     : setToCustName(toCustName);
            setToCustName(value);
        }
        if (name === "memberId") {
            // console.log("memberId", memberId)
            setMemberId(value)
        }
    };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    // };
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleToDateChange = (date) => {
        setSelectedToDate(date);
    };

    // const [getTrackingId, setGetTrackingId] = useState('')
    // const [getMerchantId, setGetMerchantId] = useState('')
    // const [getOrderId, setGetOrderId] = useState('')

    const [refundAmount, setRefundAmount] = useState("");


    const [user, setUser] = useState({
        getTrackingId: "",
        // getMerchantId: "",
        getOrderId: "",


    });

    const {
        getTrackingId,
        // getMerchantId,
        getOrderId,


    } = user;

    const [refundData, setRefundData] = useState({
        customerId: "",
        transactionId: "",
        amount: "",
        currency: "",
        transactionType: "",
        storeId: "",
        dealerId: "",
        dsrId: "",
        initiatedBy: ""
    });
    const {
        customerId,
        transactionId,
        initiatedBy,
        dsrId,
        dealerId,
        storeId,
        transactionType,
        currency,
        amount

    } = refundData
    const onInputChange = ({ target: { name, value } }, type) => {
        // setUser({ ...user, [e.target.name]: e.target.value });
        const obj = {
            ...user,

        };

        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.checkWhiteSpace(value) ? value : obj[name];
        } else {
            // obj[name] = value.trim()
            obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
        }
        setUser(obj);

    };

    const ReverseDataFunc = (currency, toCustId, id) => {




        setRefundData({
            ...refundData,
            customerId: toCustId,
            walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
            transactionId: id,
            amount: "",
            currency: currency,
            transactionType: "RF",
            storeId: "",
            dealerId: "",
            dsrId: "",
            initiatedBy: "Partner"
        })
        setReverseBtnAction(true)
    }



    const [openReverse, setOpenReverse] = React.useState(false);

    const OpenReverseFunc = () => {
        setOpenReverse(true)
    }

    const handleClose = () => {
        setOpenReverse(false)
        setReverseBtnAction(false);



    }
    const handleNoticationClose = () => {
        setNotificationRefundOpen(false)


    };
    const history = useHistory();

    const navigate = useHistory();

    useEffect(() => {
        if (getUsernameContactSuggestionRes.data.status === "success") {
            // console.log("lissttt", getUsernameContactSuggestionRes.data.list)
        }
    }, [getUsernameContactSuggestionRes.data.status])
    useEffect(() => {
        if (getUsernameSuggestionRes.data.status === "success") {
            // console.log("lissttt", getUsernameSuggestionRes.data.list)
        }
    }, [getUsernameSuggestionRes.data.status])


    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            const getUserContactReq = {
                actionCustomerMasterRequestVO: {
                    customerMobileOrName: customerOrMobName,
                    // walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
                    walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
                }
            }
            dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken))
            // console.log("userContact", getUserContactReq)
        }
    }, [regenerateTokenRes.data.status])


    const filterOptions = (options, { inputValue }) => {
        if (inputValue.length < 3) {
            return [];
        }

        const filteredOptions = options.filter(
            (option) =>
                (option.mobile && option.mobile.includes(inputValue)) ||
                (option.customerMobileOrName && option.customerMobileOrName.includes(inputValue))  // ← guard added
        );

        return filteredOptions.slice(0, 20);
    }

    const filterOptionsName = (options, { inputValue }) => {
        if (inputValue.length < 3) {
            return [];
        }

        const filteredOptionsN = options.filter(
            (option) =>
                option &&
                option.customerMobileOrName &&
                option.customerMobileOrName.includes(inputValue)
        );

        return filteredOptionsN.slice(0, 20);


    }

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            const getCustomerIdAndNameReq = {
                loginDetails: {
                    walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
                },
                actionCustomerMasterRequestVO: {
                    customerNameOrId: ""
                }
            };

            dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
        }
    }, [regenerateTokenRes.data.status]);

    const filterOptionsNameId = (options, { inputValue }) => {
        //console.log(options, inputValue, "optionsss")
        if (inputValue.length < 3) {
            return [];
        }

        const filterOptionsList = options.filter(
            (option) =>
                option.includes(inputValue) ||
                ""
        );

        return filterOptionsList.slice(0, 20);
    }


    const sendReversalInfo = () => {
        let path = `/index/ViewReversal`
        history.push(path);
        // navigate.push({
        //     pathname: `/index/ViewReversal`,
        //     // state: { param1: `${id}`, param2: `${customerId}` }
        // });
        // navigate("/index/ViewReversal")
    }
    const sendRefundReq = () => {
        setGetRefundStatus(true)
        setReverseBtnAction(false)

        // setNotificationRefundOpen(false)
        const request = {
            actionCustomerMasterRequestVO: { ...refundData, remark: getRemark || "", amount: refundAmount || "" }

        }
        dispatch(getRefunds(request, authToken));
        setGetRemark('')
        setRefundAmount('')

        // console.log("requestttss", request)


    }

    const sendRefundFunc = () => {
        // console.log("REFUNDSSSSDD", getRefundRes)
        if (getRefundStatus) {
            if (getRefundRes.data.status === "success" || getRefundRes.data.status === "Success") {
                setRefundListArray(getRefundRes.data);

                setNotificationRefundOpen(true)

            }
            if (getRefundRes.data.status === "Failed") {
                // console.log("FAILES statussss")
                // console.log("POPup", getRefundRes.data)

                setRefundListArray(getRefundRes.data);
                setNotificationRefundOpen(true)

                if (
                    getRefundRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getRefundRes.data.description == "Authorization failed"
                ) {

                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getRefundRes.data.status === "failed") {


                setRefundListArray(getRefundRes.data);
                setNotificationRefundOpen(true)

                if (
                    getRefundRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getRefundRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getRefundRes.data.status === "Pending") {
                setRefundListArray(getRefundRes.data);
                setNotificationRefundOpen(true)

                if (
                    getRefundRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getRefundRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getRefundRes.data.status === "proccessing") {
                setRefundListArray(getRefundRes.data);
                setNotificationRefundOpen(true)

                if (
                    getRefundRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getRefundRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }
    useEffect(() => {
        sendRefundFunc();
    }, [getRefundRes]);

    const getTransactionListReq = () => {
        setIsLoading(true);
        setGetTransListRefundStatus(true);
        setSearchLoading(true);  // ← start button spinner
        const req = {
            actionCustomerMasterRequestVO: {
                // walletOwnerId: localStorage.getItem("walletOwnerId") || regenerateTokenRes.data.partnerId,
                walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
                transactionId: getTrackingId,
                customerId: memberId.split("-")[0] || "",
                orderDescription: getOrderId,
                fromDate: moment(selectedDate).format("YYYY-MM-DD"),
                toDate: moment(selectedToDate).format("YYYY-MM-DD"),
                mobile: customerOrMobName.split("-")[0].substring(1),
                name: toCustName,
                page: pageNumberOne() ? 1 : pageNo + 1,
                record: rowsPerPage

            }
        };
        // console.log("refundList", req)
        dispatch(getTransactionListsRefund(req, authToken));
    };

    //To handle the page number issue while searching  transactionId
    function pageNumberOne() {
        if (getTrackingId) {
            return 1
        } else {
            return 0
        }

    }

    const getTransactionListFunc = () => {
        if (getTransListRefundStatus) {
            if (getTransactionListRefundRes.data.status === "success") {
                setIsLoading(false);
                setSearchLoading(false);  // ← stop button spinner
                setGetTransRefundListArray([].concat(getTransactionListRefundRes.data.customerMasterDetailsRequestVOList));

            }
            if (getTransactionListRefundRes.data.status === "failed") {
                setIsLoading(false);
                setSearchLoading(false);  // ← stop button spinner
                setGetTransRefundListArray(getTransactionListRefundRes.data);
                if (
                    getTransactionListRefundRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getTransactionListRefundRes.data.description == "Authorization failed"
                ) {
                    console.log("first", regenerateTokenRes.data.partnerId)
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId || localStorage.getItem("walletOwnerId"));
                }
            }
            if (getTransactionListRefundRes.data.status === "Not Found") {
                setIsLoading(false);
                setSearchLoading(false);  // ← stop button spinner
                setGetTransRefundListArray(getTransactionListRefundRes.data);
                if (
                    getTransactionListRefundRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getTransactionListRefundRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };
    useEffect(() => {

        getTransactionListReq();

    }, [pageNo, rowsPerPage])
    // useEffect(() => {
    //     if (regenerateTokenRes.data.status == "success") {
    //         getTransactionListReq();
    //     }
    // }, [regenerateTokenRes.data.status]);

    useEffect(() => {
        if (getTransactionListRefundRes.data.status) {

            getTransactionListFunc();
        }

    }, [getTransactionListRefundRes]);

    useEffect(() => {
        if (getTransactionListRefundRes.data.status === "success" && getTrackingId > 0) {   //To handle the page number issue while searching  transactionId
            setPageNo(0);
        }
    }, [getTransactionListRefundRes.data.status]);


    // useEffect(() => {
    //     if (getTransactionListRefundRes.data.status === "success") {
    //         setPage(0);
    //     }
    // }, [getTransactionListRefundRes.data.status]);

    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}

                    >
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <FormControl fullWidth>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="From Date"
                                        format="MM/dd/yyyy"
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        disableFuture={true}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <FormControl fullWidth>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="To Date"
                                        format="MM/dd/yyyy"
                                        value={selectedToDate}
                                        onChange={handleToDateChange}
                                        disableFuture={true}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                autoFocus
                                margin="dense"
                                className="removeArrows"
                                id="name"
                                label="Transaction Id"
                                type="number"
                                fullWidth
                                name="getTrackingId"
                                value={getTrackingId}
                                // onChange={onInputChange}
                                onChange={(e) => onInputChange(e, "number")}
                                style={{ marginTop: "3px" }}
                                variant="standard"
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    getCustomerIdAndNameListRes.data.currencyList || [""]
                                )}
                                getOptionLabel={(option) => option}
                                filterOptions={filterOptionsNameId}
                                value={memberId}
                                onChange={handleChange}
                                onInputChange={(event, newInputValue) => {
                                    setMemberId(newInputValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="name"
                                        label="Member ID"
                                        style={{ marginTop: "3px" }}
                                        // required
                                        type="tel"
                                        fullWidth
                                        {...params}
                                        // value={merchantID}
                                        name="memberId"
                                        // onChange={(e) => onInputChange(e, "number")}

                                        variant="standard"
                                        sx={{
                                            "& .MuiInput-underline:before": {
                                                borderBottomColor: "gray", // White color for the underline before focus
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottomColor: "gray", // White color on hover
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottomColor: "gray", // White color after focus
                                            },
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        {/* <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                autoFocus
                                margin="dense"
                                className="removeArrows"
                                id="name"
                                label="Merchant Id"
                                type="number"
                                fullWidth
                                name="getMerchantId"
                                value={getMerchantId}
                                variant="standard"

                                // onChange={onInputChange}
                                onChange={(e) => onInputChange(e, "number")}
                                style={{ marginTop: "3px" }}
                            />
                        </Grid> */}
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                autoFocus
                                margin="dense"
                                // className="removeArrows"
                                id="name"
                                label="Order Id"
                                // type="number"
                                fullWidth
                                name="getOrderId"
                                value={getOrderId}
                                variant="standard"

                                // onChange={onInputChange}
                                onChange={(e) => onInputChange(e, "both")}
                                style={{ marginTop: "3px" }}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    getUsernameContactSuggestionRes.data.list || [""]
                                )}
                                getOptionLabel={(option) => "+" + option.countryCode + " " + option.mobile + "-" + option.customerMobileOrName}
                                filterOptions={filterOptions}
                                renderInput={(params) => (
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="name"
                                        label="Contact"
                                        style={{ marginTop: "3px" }}
                                        type="text"
                                        fullWidth
                                        {...params}
                                        value={customerOrMobName || ""}
                                        name="customerOrMobName"
                                        onBlur={handleChange}
                                        variant="standard"
                                        sx={{
                                            "& .MuiInput-underline:before": {
                                                borderBottomColor: "gray", // White color for the underline before focus
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottomColor: "gray", // White color on hover
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottomColor: "gray", // White color after focus
                                            },
                                        }}

                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    getUsernameContactSuggestionRes.data.list || [""]
                                )}
                                getOptionLabel={(option) => option.customerMobileOrName}
                                filterOptions={filterOptionsName}
                                renderInput={(params) => (
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="name"
                                        label="Beneficiary Name"
                                        style={{ marginTop: "3px" }}
                                        type="text"
                                        fullWidth
                                        {...params}
                                        value={toCustName || ""}
                                        name="toCustName"
                                        onBlur={handleChange}
                                        variant="standard"
                                        sx={{
                                            "& .MuiInput-underline:before": {
                                                borderBottomColor: "gray", // White color for the underline before focus
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottomColor: "gray", // White color on hover
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottomColor: "gray", // White color after focus
                                            },
                                        }}

                                    />
                                )}
                            />

                            {/* <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                label="Beneficiary Name"
                                type="tel"
                                fullWidth
                                value={toCustName}
                                name="toCustName"
                                onChange={handleChange}
                                style={{ marginTop: "3px" }}
                            /> */}
                        </Grid>

                    </Grid>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1.5rem",
                            marginBottom: "15px"
                        }}
                    >
                        <Grid item md={5}>

                            {/* <CustomButton
                                style={{
                                    padding: "8px",
                                    marginLeft: "15px"
                                }}
                                onClick={getTransactionListReq}
                            >
                                Search <SearchIcon />
                            </CustomButton> */}
                            <CustomButton
                                style={{ padding: "8px" }}
                                onClick={getTransactionListReq}
                                disabled={searchLoading}  // ← prevent double click
                            >
                                {searchLoading ? (
                                    <>
                                        Searching...&nbsp;
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    </>
                                ) : (
                                    <>
                                        Search <SearchIcon />
                                    </>
                                )}
                            </CustomButton>
                        </Grid>

                    </Grid>
                </Card>
                {isLoading ? (
                    <LoadingSpinner />
                ) : getTransRefundListArray.length == undefined ||
                    !getTransListRefundStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography
                                        variant="body1"
                                        style={{ fontWeight: "700" }}
                                        className="themeText"
                                    >
                                        Refund Details
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="my-3">
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">

                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Transaction Date{" "}
                                                </TableCell>
                                                {/* <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    {" "}
                                                    Customer ID
                                                </TableCell> */}
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    {" "}
                                                    Transaction ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    {" "}
                                                    Order ID
                                                </TableCell>
                                                {/* <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Customer Name{" "}
                                                </TableCell> */}
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Captured Amount
                                                </TableCell>

                                                {/* <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Refunded Amount
                                        </TableCell> */}
                                                {/* <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Currency
                                                </TableCell> */}
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Status
                                                </TableCell>
                                                {/* <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Mobile Number
                                                </TableCell> */}
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Remark
                                                </TableCell>
                                                {/* <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Action
                                        </TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getTransRefundListArray &&
                                                []
                                                    .concat(getTransRefundListArray)
                                                    // .slice(
                                                    //     page * rowsPerPage,
                                                    //     page * rowsPerPage + rowsPerPage
                                                    // )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>

                                                            <TableCell align="center">
                                                                {row.registeredTime}
                                                            </TableCell>
                                                            {/* <TableCell align="center">
                                                                {row.fromCustId}
                                                            </TableCell> */}
                                                            <TableCell align="center">
                                                                {row.id}
                                                            </TableCell>
                                                            <TableCell align="center">{row.orderDescription}</TableCell>
                                                            {/* <TableCell align="center">
                                                                {row.name}
                                                            </TableCell> */}

                                                            {/* <TableCell align="center">{row.verifyStatus}</TableCell> */}
                                                            {/* <TableCell align="center">{row.orderDescription}</TableCell> */}
                                                            <TableCell align="center">
                                                                {" "}
                                                                {getSymbolFromCurrency(row.currency) +
                                                                    " " + row.amount}
                                                                {/* {row.transactionAmount} */}
                                                            </TableCell>
                                                            {/* <TableCell align="center">{row.amount}</TableCell> */}
                                                            {/* <TableCell align="center">{row.currency}</TableCell> */}
                                                            <TableCell align="center">{row.status}</TableCell>
                                                            {/* <TableCell align="center">{row.mobile}</TableCell> */}

                                                            <TableCell align="center">
                                                                <Tooltip title="Reverse">

                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "10px"
                                                                        }}
                                                                        onClick={() =>
                                                                            ReverseDataFunc(

                                                                                row.currency,
                                                                                row.toCustId,
                                                                                row.id,
                                                                            )
                                                                        }


                                                                    >
                                                                        <RotateLeftIcon />

                                                                    </CustomButton>
                                                                </Tooltip>
                                                            </TableCell>




                                                        </TableRow>
                                                    ))}
                                        </TableBody>

                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={getTransactionListRefundRes.data.count}
                                        rowsPerPage={rowsPerPage}
                                        page={pageNo}

                                        onPageChange={handleChangePageForward}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    // handleChangeRowsPerPage={handleChangeRowsPerPage}
                                    // page={page}
                                    // onChangePage={handleChangePage}
                                    // onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />

                                </TableContainer>

                            </Grid>
                        </Card>
                    </div>
                )}
                <div>
                    <Dialog open={reverseBtnAction} onClose={handleClose}>
                        {/* <DialogTitle> Do you really want to Refund?</DialogTitle> */}
                        <DialogTitle style={{ width: "400px" }}>Refund Transactions</DialogTitle>


                        <DialogContent>
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Refund Amount*"
                                name="refundAmount"
                                type="text"
                                fullWidth
                                variant="standard"
                                onChange={handleChangeEvent}
                                // onChange={handleChange}
                                value={refundAmount}
                            />
                            <p className="refundMsgs"
                            >Please provide reason for refund</p>
                            {/* <TextField
                                autoFocus
                                margin="dense"
                                label="Refund Reason*"
                                name="getRemark"
                                type="text"
                                fullWidth
                                variant="standard"
                                onChange={handleChange}
                                value={getRemark || ""}
                            /> */}
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Refund Reason*"
                                name="getRemark"
                                type="text"
                                fullWidth
                                variant="standard"
                                onChange={handleChange}
                                value={getRemark || ""}
                                // error={!!remarkError}
                                // helperText={remarkError}
                                inputProps={{
                                    // Extra safety: prevent paste of invalid characters
                                    onPaste: (e) => {
                                        const paste = e.clipboardData.getData("text");
                                        const allowedPattern = /^[a-zA-Z0-9 '"\\-]*$/;
                                        if (!allowedPattern.test(paste)) {
                                            e.preventDefault();
                                        }
                                    }
                                }}
                            />

                            <p style={{ marginTop: "12px" }}
                                className="refundMsgs"
                            >
                                Do you really want to Reverse the Transaction?
                            </p>


                        </DialogContent>
                        <DialogActions>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleClose}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                disabled={!getRemark}
                                onClick={sendRefundReq}
                            >
                                Yes
                            </CustomButton>

                        </DialogActions>
                    </Dialog>
                </div>
                {/* <div>
                    <Dialog open={reverseBtnAction} onClose={handleClose}>
                        <DialogTitle>
                            Do you really want to Refund?
                        </DialogTitle>

              
                        <TextField
                            autoFocus
                            margin="dense"
                            label=" Remark"
                            name="getRemark"
                            type="text"
                            // fullWidth
                            variant="standard"
                            onChange={handleChange}
                            value={getRemark || ""}
                        />
                        <DialogActions className="p-3">
                            <CustomButton
                                style={{
                                    // backgroundColor: "#fff",
                                    // color: "#000",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleClose}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    // backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={sendRefundReq}

                            >
                                Yes
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div> */}
                <div>
                    <Dialog open={openReverse} onClose={handleClose}>
                        <DialogTitle style={{ width: "400px" }}>
                            Do you really want to reverse this transaction?
                        </DialogTitle>

                        <DialogActions className="p-3">
                            <CustomButton
                                style={{
                                    // backgroundColor: "#fff",
                                    // color: "#000",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleClose}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    // backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={sendReversalInfo}
                            >
                                OK
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            </Layout>


            {(RefundArray.status == "success" || RefundArray.status == "Success") && (
                <div>
                    <Dialog
                        open={notificationRefundOpen}
                        onClose={handleNoticationClose}
                    >
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {RefundArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
            {RefundArray.status == "Failed" && (
                <div>
                    <Dialog
                        open={notificationRefundOpen}
                        onClose={handleNoticationClose}
                    >
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {RefundArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
            {RefundArray.status == "failed" && (
                <div>
                    <Dialog
                        open={notificationRefundOpen}
                        onClose={handleNoticationClose}
                    >
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {RefundArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
            {RefundArray.status == "Pending" && (
                <div>
                    <Dialog
                        open={notificationRefundOpen}
                        onClose={handleNoticationClose}
                    >
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={pending} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {RefundArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
            {RefundArray.status == "proccessing" && (
                <div>
                    <Dialog
                        open={notificationRefundOpen}
                        onClose={handleNoticationClose}
                    >
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={proccessing} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {RefundArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default Refund;